import scrollTo from 'utils/scrollTo';
import DOMHelper from 'utils/DOMHelpers';

/**
 * @module ScrollTo
 */
class ScrollTo {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     */
    constructor(element) {
        this._element = element;

        this.load();
    }

    /**
     * Construct module
     */
    load() {
        this._element.addEventListener('click', () => this._onClick());
    }

    /**
     * On element click event
     */
    _onClick() {
        this._getTargetPosition();
        scrollTo(window, this._targetPosition);
    }

    /**
     * Get position of the element to scroll to
     */
    _getTargetPosition() {
        this._target = this._element.getAttribute('href');
        this._targetElement = document.querySelector(this._target);

        if (!this._targetElement) {
            return;
        }

        this._targetPosition = DOMHelper.getPosition(this._targetElement);
    }

}

// Exports
export default ScrollTo;
